<template>
  <div class="overtime" style="margin-top:1px;">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'100px'}">
        <van-checkbox-group ref="checkboxGroup" v-model="result">
          <van-swipe-cell v-for="(info, index) in workOvertime" :key="info.overtime_code" clickable>
            <van-cell :title="info.user_name" @click="toggle(index)">
              <template v-if="info.approval === '1'" #icon>
                <van-checkbox ref="checkboxes" :name="info.overtime_code" icon-size="16px" style="margin-right:10px" />
              </template>
              <template slot="label">
                <span>{{ worktimeChange(info) }}</span>
                <br>
              </template>
              <span :style="{ color: leaveStatusSet(info.approval)}">{{ approvalStatusChange(info) }}</span>
            </van-cell>
            <template v-if="info.approval === '1'" #right>
              <van-button square text="同意" type="primary" class="button-size" @click="onClickCommit(info)" />
              <van-button square text="时段审批" type="info" class="button-size" @click="onClickTimeIntervalCommit(info)" />
              <van-button square text="拒绝" type="danger" class="button-size" @click="onClickNotCommit(info)" />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </div>
    </van-pull-refresh>
    <van-tabbar v-if="$parent.params.approval === '0'" style="bottom:50px;">
      <van-tabbar-item style="align-items: flex-start;padding-left: 16px;">
        <van-checkbox v-model="checked" icon-size="16px" @click="checkAll">全选</van-checkbox>
      </van-tabbar-item>
      <van-tabbar-item style="align-items: flex-end;padding-right: 16px;">
        <van-button type="primary" size="small" @click="onClickAllCommit()">同意</van-button>&nbsp;
        <van-button type="info" size="small" @click="onClickAllTimeIntervalCommit()">时段审批</van-button>&nbsp;
        <van-button type="danger" size="small" @click="onClickAllNoCommit()">拒绝</van-button>
      </van-tabbar-item>
    </van-tabbar>
    <van-dialog
      v-model="dialogshow"
      title="审批承认时间"
      show-confirm-button
      show-cancel-button
      :before-close="onBeforeClose"
    >
      <!-- 加班日期 -->
      <van-field
        v-model="overtimeDate"
        label="日期"
        readonly
        required
        is-link
        placeholder="选择日期"
        @click="popupDate=true"
      />
      <!-- 加班开始时间 -->
      <van-field
        v-model="dataOverTimeStart"
        label="开始时间"
        readonly
        required
        is-link
        placeholder="选择开始时间"
        @click="popupTimeStart=true"
      />
      <!-- 加班日期结束时间 -->
      <van-field
        v-model="dataOverTimeEnd"
        label="结束时间"
        readonly
        required
        is-link
        style="margin-bottom: 78px;"
        placeholder="选择结束时间"
        @click="popupTimeEnd=true"
      />
      <!-- 加班日期展开 -->
      <van-popup v-model="popupDate" position="bottom">
        <van-datetime-picker
          v-model="pickerCurrentDate"
          type="date"
          @confirm="confirmDate()"
          @cancel="popupDate=false"
        />
      </van-popup>
      <!-- 加班开始时间选择器展开 -->
      <van-popup v-model="popupTimeStart" position="bottom">
        <van-datetime-picker
          v-model="pickerCurrentTime"
          type="time"
          :filter="filterDatatime"
          @confirm="confirmTimeStart()"
          @cancel="popupTimeStart=false"
        />
      </van-popup>
      <!-- 加班结束时间选择器展开 -->
      <van-popup v-model="popupTimeEnd" position="bottom">
        <van-datetime-picker
          v-model="pickerCurrentTimeEnd"
          type="time"
          :filter="filterDatatime"
          @confirm="confirmTimeEnd()"
          @cancel="popupTimeEnd=false"
        />
      </van-popup>
    </van-dialog>
  </div>
</template>
<script>
import { Notify } from 'vant'
import request from '@/utils/request'
const moment = require('moment')
const approvals = { '1': '未批准', '2': '已批准', '9': '已拒绝' }
export default {
  name: 'Approval',
  data() {
    return {
      workOvertime: [],
      isLoading: false,
      freshHeight: '100%',
      result: [],
      checked: false,
      checkedAll: false,
      dialogshow: false, // dialog显示隐藏变量
      overtimeDate: '', // 加班日期
      dataOverTimeStart: '18:00', // 开始时间v-model
      dataOverTimeEnd: '', // 结束时间v-model
      popupDate: false, // 加班日期选择器显示隐藏变量
      popupTimeStart: false, // 开始时间选择器显示隐藏变量
      popupTimeEnd: false, // 结束时间选择器显示隐藏变量
      pickerCurrentDate: new Date(moment()),
      pickerCurrentTime: moment().format('HH:mm'),
      pickerCurrentTimeEnd: moment().format('HH:mm'),
      onePeriodApprovalArray: [], // 一条审批参数数组
      manyPeriodApprovalArray: [], // 多条审批参数数组
      oneManyFlg: '',
      oldOvertimeDate: '',
      oldDataOverTimeStart: '',
      oldDataOverTimeEnd: '',
      overtime_time_s: [],
      overtime_time_e: [],
      flg: '0'
    }
  },

  watch: {
    result() {
      if (this.result.length === this.workOvertime.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    dataOverTimeStart: {
      handler(newVal, oldVal) {
        const overtime_time_s = moment(this.onePeriodApprovalArray.overtime_time_s).format('YYYY-MM-DD')
        this.onePeriodApprovalArray.overtime_time_s = overtime_time_s + ' ' + newVal
        this.manyPeriodApprovalArray.forEach(over => {
          over.overtime_time_s = moment(over.overtime_time_s).format('YYYY-MM-DD') + ' ' + newVal
        })
      }
    },
    dataOverTimeEnd: {
      handler(newVal, oldVal) {
        const overtime_time_e = moment(this.onePeriodApprovalArray.overtime_time_e).format('YYYY-MM-DD')
        this.onePeriodApprovalArray.overtime_time_e = overtime_time_e + ' ' + newVal
        this.manyPeriodApprovalArray.forEach(over => {
          over.overtime_time_e = moment(over.overtime_time_e).format('YYYY-MM-DD') + ' ' + newVal
        })
      }
    }
  },
  created: function() {
    this.onRefresh()
  },
  mounted() {
    this.freshHeight = document.documentElement.clientHeight - this.$refs.fresh.getBoundingClientRect().top
  },
  methods: {
    // 获取人名
    worktimeChange(info) {
      if (info.leave_flg === '0') {
        return moment(info.overtime_time_s).format('YYYY-MM-DD') + '~' + moment(info.overtime_time_e).format('YYYY-MM-DD')
      } else {
        return moment(info.overtime_date).format('YYYY-MM-DD') + ' ' + moment(info.overtime_time_s).format('HH:mm') + '-' + moment(info.overtime_time_e).format('HH:mm')
      }
    },
    // 请假类型
    leaveTypeChange(info) {
      const status = this.GLOBAL.BASE_LEAVE_STATUS
      return status[info.leave_type]
    },
    // 状态区分
    approvalStatusChange(info) {
      return approvals[info.approval]
    },
    // 状态颜色区分
    leaveStatusSet(approval) {
      switch (approval) {
        case '9': return 'red'
        case '2': return 'green'
        default: return 'orange'
      }
    },
    // 单选
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    // 全选
    checkAll() {
      this.checked = !this.checked
      this.checkedAll = !this.checkedAll
      // this.$refs.checkboxGroup.toggleAll(this.checked)
      this.$refs.checkboxGroup.toggleAll(this.checkedAll)
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll()
    },
    // 同意
    onClickAllCommit() {
      if (this.result.length === 0) {
        Notify({ type: 'warning', message: '请选择项目' })
      } else {
        const datas = []
        this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
          .then(() => {
            this.result.forEach(leaveNum => {
              const element = this.workOvertime.filter(v => String(v.overtime_code).indexOf(leaveNum) > -1)[0]
              element.approval = '2'
              element.approval_user = this.$store.getters.usercode
              element.overtime_code = leaveNum.toString()
              datas.push(element)
            })
            this.saveData(datas)
          }).catch(() => {})
      }
    },
    // 拒绝
    onClickAllNoCommit() {
      if (this.result.length === 0) {
        Notify({ type: 'warning', message: '请选择项目' })
      } else {
        const datas = []
        this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
          .then(() => {
            this.result.forEach(leaveNum => {
              const element = this.workOvertime.filter(v => String(v.overtime_code).indexOf(leaveNum) > -1)[0]
              element.approval = '9'
              element.approval_user = this.$store.getters.usercode
              element.overtime_code = leaveNum.toString()
              datas.push(element)
            })
            this.saveData(datas)
          }).catch(() => {})
      }
    },
    // 多条时段审批
    onClickAllTimeIntervalCommit() {
      this.overtimeDate = ''
      this.pickerCurrentDate = new Date(moment().format('YYYY-MM-DD'))
      this.dataOverTimeStart = '18:00'
      // 开始时间选择器
      this.pickerCurrentTime = '18:00'
      // 结束时间选择器
      this.pickerCurrentTimeEnd = '19:00'
      this.dataOverTimeEnd = ''
      this.manyPeriodApprovalArray = []
      this.overtime_time_s = []
      this.overtime_time_e = []
      if (this.result.length === 0) {
        Notify({ type: 'warning', message: '请选择项目' })
      } else {
        this.result.forEach(leaveNum => {
          const element = this.workOvertime.filter(v => String(v.overtime_code).indexOf(leaveNum) > -1)[0]
          this.manyPeriodApprovalArray.push(JSON.parse(JSON.stringify(element)))
        })
        this.manyPeriodApprovalArray.forEach(leave => {
          this.overtime_time_s.push(moment(leave.overtime_time_s, 'YYYY-MM-DD HH:mm').format('HH:mm').replace(':', ''))
          this.overtime_time_e.push(moment(leave.overtime_time_e, 'YYYY-MM-DD HH:mm').format('HH:mm').replace(':', ''))
        })
        this.oneManyFlg = 'ManyFlg'
        this.dialogshow = true
      }
    },
    // 单条审批
    onClickCommit(info) {
      const datas = []
      this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
        .then(() => {
          info.approval = '2'
          info.approval_user = this.$store.getters.usercode
          info.overtime_code = info.overtime_code.toString()
          datas.push(info)
          this.saveData(datas)
        })
        .catch(() => {})
    },
    // 单条拒绝
    onClickNotCommit(info) {
      const datas = []
      this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
        .then(() => {
          info.approval = '9'
          info.approval_user = this.$store.getters.usercode
          info.overtime_code = info.overtime_code.toString()
          datas.push(info)
          this.saveData(datas)
        })
        .catch(() => {})
    },
    // 单条时段审批
    onClickTimeIntervalCommit(info) {
      // 加班日期
      this.overtimeDate = info.overtime_date
      // 加班日期选择器
      this.pickerCurrentDate = new Date(info.overtime_date)
      // 开始时间
      this.dataOverTimeStart = moment(info.overtime_time_s, 'YYYY-MM-DD HH:mm').format('HH:mm')
      // 开始时间选择器
      this.pickerCurrentTime = moment(info.overtime_time_s, 'YYYY-MM-DD HH:mm').format('HH:mm')
      // 结束时间
      this.dataOverTimeEnd = moment(info.overtime_time_e, 'YYYY-MM-DD HH:mm').format('HH:mm')
      // 结束时间选择器
      this.pickerCurrentTimeEnd = moment(info.overtime_time_e, 'YYYY-MM-DD HH:mm').format('HH:mm')
      this.oldOvertimeDate = info.overtime_date
      this.oldDataOverTimeStart = moment(info.overtime_time_s, 'YYYY-MM-DD HH:mm').format('HH:mm')
      this.oldDataOverTimeEnd = moment(info.overtime_time_e, 'YYYY-MM-DD HH:mm').format('HH:mm')
      this.onePeriodApprovalArray = {
        'approval': '2',
        'approval_date': info.approval_date,
        'approval_user': this.$store.getters.usercode,
        'approval_user_name': info.approval_user_name,
        'overtime_code': info.overtime_code.toString(),
        'overtime_date': info.overtime_date,
        'overtime_target': info.overtime_target,
        'overtime_time_e': info.overtime_date + ' ' + this.dataOverTimeEnd,
        'overtime_time_s': info.overtime_date + ' ' + this.dataOverTimeStart,
        'user_name': info.user_name
      }
      this.oneManyFlg = 'one'
      this.dialogshow = true
    },
    // 数据保存处理
    saveData(infos) {
      const self = this
      self.$toast.loading({
        duration: 10000,
        message: '加载中...',
        forbidClick: true
      })
      request({ url: 'C04/aprvOvers/', method: 'post', data: infos })
        .then(function(response) {
          self.onRefresh()
          self.$toast.success('Submit Successed!')
          self.dialogshow = false
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    },
    // 页面刷新
    onRefresh() {
      const self = this
      self.checked = false
      self.result.length = 0
      self.workOvertime = []
      const params = this.$parent.params
      request({ url: '/C04/aprvOvers', params: params })
        .then(function(response) {
          if (response.code === 0) {
            if (params.approval === '0') {
              self.workOvertime = response.data.filter(v => v.approval.indexOf('1') > -1)
            } else if (params.approval === '1') {
              self.workOvertime = response.data.filter(v => v.approval.indexOf('2') > -1 || v.approval.indexOf('9') > -1)
            } else {
              self.workOvertime = response.data
            }
          }
          self.isLoading = false
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    },
    // 选择时间进行筛选
    filterDatatime(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 15 === 0)
      }
      return options
    },
    // 加班日期选择器
    confirmDate() {
      this.overtimeDate = moment(this.pickerCurrentDate).format('YYYY-MM-DD')
      this.popupDate = false
    },
    // 加班开始时间选择器
    confirmTimeStart() {
      this.dataOverTimeStart = this.pickerCurrentTime
      this.popupTimeStart = false
      if (this.dataOverTimeEnd === '') {
        this.dataOverTimeEnd = this.dataOverTimeStart
        this.pickerCurrentTimeEnd = this.dataOverTimeStart
      }
      if (this.dataOverTimeStart > this.dataOverTimeEnd) {
        this.dataOverTimeEnd = this.dataOverTimeStart
        this.pickerCurrentTimeEnd = this.dataOverTimeStart
        this.$toast('输入的日期区间无效！')
        return
      }
    },
    // 加班结束时间选择器
    confirmTimeEnd() {
      this.dataOverTimeEnd = this.pickerCurrentTimeEnd
      // 关闭加班结束时间选择器
      this.popupTimeEnd = false
      if (this.dataOverTimeStart > this.dataOverTimeEnd) {
        this.dataOverTimeEnd = this.dataOverTimeStart
        this.pickerCurrentTimeEnd = this.dataOverTimeStart
        this.$toast('输入的日期区间无效！')
        return
      }
      if (this.dataOverTimeStart === '') {
        this.dataOverTimeStart = this.dataOverTimeEnd
      }
    },
    onBeforeClose(action, done) {
      // 提交按钮
      if (action === 'confirm') {
        if (this.overtimeDate === '') {
          this.$toast('请选择日期！')
        } else if (this.dataOverTimeEnd === '') {
          this.$toast('请选择结束时间！')
        } else {
          if (this.oneManyFlg === 'one') {
            if (this.overtimeDate !== this.oldOvertimeDate) {
              this.$toast('所选日期不符合')
            } else if (this.dataOverTimeStart < this.oldDataOverTimeStart) {
              this.$toast('所选开始时间早于该人员已加班开始时间')
            } else if (this.dataOverTimeEnd > this.oldDataOverTimeEnd) {
              this.$toast('所选结束时间晚于该人员已加班结束时间')
            } else if (this.dataOverTimeStart === this.dataOverTimeEnd) {
              this.$toast('开始时间不能等于结束时间')
            } else {
              this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
                .then(() => {
                  const infos = []
                  infos.push(this.onePeriodApprovalArray)
                  this.saveData(infos)
                })
                .catch(() => {})
            }
          } else {
            let trigger = true
            this.manyPeriodApprovalArray.forEach(leaveNum => {
              if (this.overtimeDate !== leaveNum.overtime_date) {
                this.$toast('所选日期不符合')
                this.flg = '0'
              } else if (moment(leaveNum.overtime_time_s, 'YYYY-MM-DD HH:mm').format('HH:mm').replace(':', '') < Math.min.apply(null, this.overtime_time_s)) {
                this.$toast('所选开始时间早于该人员已加班开始时间')
                this.flg = '0'
              } else if (moment(leaveNum.overtime_time_e, 'YYYY-MM-DD HH:mm').format('HH:mm').replace(':', '') > Math.min.apply(null, this.overtime_time_e)) {
                this.$toast('所选结束时间晚于该人员已加班结束时间')
                this.flg = '0'
              } else if (leaveNum.overtime_time_s === leaveNum.overtime_time_e) {
                this.$toast('开始时间不能等于结束时间')
                this.flg = '0'
              } else {
                leaveNum.approval = '2'
                leaveNum.approval_user = this.$store.getters.usercode
                leaveNum.overtime_code = leaveNum.overtime_code.toString()
                this.flg = '1'
              }
              if (this.flg === '0') {
                trigger = false
              }
            })
            if (trigger === true) {
              this.$dialog.confirm({ title: '确认信息', message: '是否确定执行操作？' })
                .then(() => {
                  this.saveData(this.manyPeriodApprovalArray)
                })
                .catch(() => {})
            }
          }
        }
        return done(false)
      // 取消按钮
      } else {
        return done()
      }
    }
  }
}
</script>
<style scoped>
    .van-cell__value{
      max-width: 30%
    }
    /* 按钮大小 */
    .button-size{
        height: 100%;
    }
</style>
